// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"23802258","395":"e3b07b3a"}[chunkId] + ".chunk.js";
};